import './Topnavbar.css';
import { Card, Group, Title, Paper, Text, Menu, UnstyledButton, useMantineTheme, Avatar, Skeleton, ThemeIcon, Drawer, Badge, Divider, Stack, SimpleGrid, Button } from "@mantine/core";
import {
    IconChevronDown,
    IconLogout,
    IconSettings,
    IconUser,
    IconWallet, IconChevronRight, IconRefresh
} from '@tabler/icons-react';
import cx from 'clsx';
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Userauthcontexthooks } from '../Hooks/Userauthcontexthooks';
import { Get_User_Details, Get_User_Wallet_Details } from '../apicall';
import { message } from 'antd';
import dayjs from 'dayjs';
import { useWallet } from '../Context/Walletcontext';





const Info = ({ label, value }) => (

    <div>

        <Text
            size="xs"
            c="dimmed"
            fw={600}
            tt="uppercase"
        >
            {label}
        </Text>

        <Text
            fw={600}
            mt={4}
        >
            {value || "-"}
        </Text>

    </div>

);



const Topnavbar = ({ Headername }) => {
    const { user, dispatch } = Userauthcontexthooks();
    const theme = useMantineTheme();
    const { wallet, refreshWallet } = useWallet();
    const [userMenuOpened, setUserMenuOpened] = useState(false);
    const Navigate = useNavigate();
    const [WalletDrawer, setWalletDrawer] = useState(false);
    const [UserprofileDrawer, setUserprofileDrawer] = useState(false);
    const [userLoading, setUserloading] = useState(true);
    const [userWalletloading, setUserwalletloading] = useState(true);
    const [userData, setUserdata] = useState('');
    const [userWallet, setUserwallet] = useState(0);
    const [refreshwalletloading, setrefreshwalletloading] = useState(false);

    function accountSettings_redirect() {
        Navigate('/user-account-settings')
    }
    function Logout_user() {
        localStorage.removeItem('user');
        localStorage.removeItem('expiryTime');
        dispatch({ type: 'LOGOUT' });
        message.success('Logout Successfully', 1.5, () => {
            Navigate('/');
        });

    }
    const Get_user_wallet = async () => {

        try {
            setrefreshwalletloading(true);
            const data = await Get_User_Wallet_Details();
            if (data.success) {
                // console.log(data);
                setUserwallet(data?.Userwallet);
                message.success('Wallet refreshed');
                //setUserwalletloading(false);
            }
            // console.log(data);
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setUserwalletloading(false);
            setrefreshwalletloading(false);
        }
    }
    useEffect(() => {
        const Get_user_profile = async () => {
            try {
                //setUserloading(false);
                const data = await Get_User_Details();
                if (data.success) {
                    // console.log(data);
                    setUserdata(data?.user);
                }
                // console.log(data);
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );

            } finally {
                setUserloading(false);
            }
        }
        const Get_user_wallet = async () => {
            try {
                const data = await Get_User_Wallet_Details();
                if (data.success) {
                    // console.log(data);
                    setUserwallet(data?.Userwallet);
                    //setUserwalletloading(false);
                }
                // console.log(data);
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );

            } finally {
                setUserwalletloading(false);
            }
        }

        if (user) {
            Get_user_profile();
            Get_user_wallet();
            refreshWallet();
        }
    }, [user, refreshWallet])
    return (
        <>
            <Drawer
                opened={WalletDrawer}
                onClose={() => setWalletDrawer(false)}
                title="Wallet Details"
                position="right"
                size="md"
                offset={8} radius="md"
                overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}
            >
                <Paper withBorder radius="md" p="md">

                    <Group justify="space-between">

                        <div>

                            <Text c="dimmed" size="xs">
                                Available Balance
                            </Text>

                            <Text fw={700} size="xl" c="green">
                                ₹ {userWallet?.mainBalance?.toLocaleString()}
                            </Text>

                        </div>

                        <Badge
                            color={
                                userWallet?.walletStatus === "ACTIVE"
                                    ? "green"
                                    : "red"
                            }
                            size="lg"
                        >
                            {userWallet?.walletStatus}
                        </Badge>

                    </Group>

                </Paper>
                <Paper mt="md" withBorder radius="md" p="md">

                    <Stack gap="xs">

                        <Group justify="space-between">
                            <Text c="dimmed">
                                Wallet Status
                            </Text>

                            <Badge
                                color="green"
                            >
                                {userWallet?.walletStatus}
                            </Badge>

                        </Group>

                        <Divider />

                        <Group justify="space-between">

                            <Text c="dimmed">
                                Main Balance
                            </Text>

                            <Text fw={600}>
                                ₹ {userWallet?.mainBalance}
                            </Text>

                        </Group>

                        <Divider />

                        <Group justify="space-between">

                            <Text c="dimmed">
                                Hold Balance
                            </Text>

                            <Text fw={600}>
                                ₹ {userWallet?.holdBalance}
                            </Text>

                        </Group>

                        <Divider />

                        <Group justify="space-between">

                            <Text c="dimmed">
                                Available Balance
                            </Text>

                            <Text
                                fw={700}
                                c="green"
                            >
                                ₹ {userWallet?.mainBalance - userWallet?.holdBalance}
                            </Text>

                        </Group>

                        <Divider />

                        <Group justify="space-between">

                            <Text c="dimmed">
                                Wallet Blocked
                            </Text>

                            <Badge
                                color={
                                    userWallet?.isWalletBlocked
                                        ? "red"
                                        : "green"
                                }
                            >
                                {userWallet?.isWalletBlocked
                                    ? "YES"
                                    : "NO"}
                            </Badge>

                        </Group>

                        <Divider />

                        <Group justify="space-between">

                            <Text c="dimmed">
                                Created On
                            </Text>

                            <Text>
                                {dayjs(userWallet?.createdAt).format("DD MMM YYYY")}
                            </Text>

                        </Group>

                        <Divider />

                        <Group justify="space-between">

                            <Text c="dimmed">
                                Last Updated
                            </Text>

                            <Text>
                                {dayjs(userWallet?.updatedAt).format("DD MMM YYYY hh:mm A")}
                            </Text>

                        </Group>

                    </Stack>

                </Paper>
                <Button
                    leftSection={<IconRefresh size={18} />}
                    variant="light"
                    onClick={Get_user_wallet}
                    loading={refreshwalletloading}
                    fullWidth
                    mt={'xs'}
                >
                    Refresh
                </Button>
            </Drawer>
            <Drawer
                opened={UserprofileDrawer}
                onClose={() => setUserprofileDrawer(false)}
                title="Profile"
                position="top"
                size="md"
                offset={8} radius="md"
                overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}
            >
                <Paper withBorder radius="lg" p="xl">

                    <Group>

                        <Avatar
                            size={80}
                            radius="xl"
                            color="initials"
                            name={userData.userName}
                        />

                        <div>

                            <Title order={3}>
                                {userData.userName}
                            </Title>

                            <Group mt={5}>

                                <Badge color="blue">
                                    {userData.userCode}
                                </Badge>

                                <Badge color="green">
                                    {userData.acc_type}
                                </Badge>

                                <Badge
                                    color={
                                        userData.isaccountblocked
                                            ? "red"
                                            : "green"
                                    }
                                >
                                    {userData.isaccountblocked
                                        ? "Blocked"
                                        : "Active"}
                                </Badge>

                            </Group>

                        </div>

                    </Group>

                </Paper>
                <Paper withBorder radius="md" p="lg" mt="lg">

                    <Title order={4}>Personal Information</Title>

                    <SimpleGrid cols={2} mt="md">

                        <Info label="Name" value={userData.userName} />

                        <Info label="Mobile" value={userData.mobile} />

                        <Info label="Email" value={userData.email} />

                        <Info
                            label="Date of Birth"
                            value={dayjs(userData.dob).format("DD MMM YYYY")}
                        />

                        <Info
                            label="Gender"
                            value={userData.gender}
                        />

                    </SimpleGrid>

                </Paper>

                <Paper withBorder radius="md" p="lg" mt="lg">

                    <Title order={4}>
                        Business Details
                    </Title>

                    <SimpleGrid cols={2} mt="md">

                        <Info
                            label="Business Name"
                            value={userData.business_name}
                        />

                        <Info
                            label="Business Type"
                            value={userData.business_type}
                        />

                        <Info
                            label="GST Number"
                            value={userData.gst_no || "Not Available"}
                        />

                        <Info
                            label="MSME Number"
                            value={userData.msme_no || "Not Available"}
                        />

                    </SimpleGrid>

                </Paper>

                <Paper withBorder radius="md" p="lg" mt="lg">

                    <Title order={4}>
                        Address
                    </Title>

                    <SimpleGrid cols={2} mt="md">

                        <Info
                            label="Address"
                            value={userData.address}
                        />

                        <Info
                            label="City"
                            value={userData.city}
                        />

                        <Info
                            label="State"
                            value={userData.state}
                        />

                        <Info
                            label="Pincode"
                            value={userData.pincode}
                        />

                    </SimpleGrid>

                </Paper>

                <Paper withBorder radius="md" p="lg" mt="lg">

                    <Title order={4}>
                        KYC
                    </Title>

                    <SimpleGrid cols={2} mt="md">

                        <Info
                            label="PAN"
                            value={userData.pan_no}
                        />

                        <Info
                            label="Aadhaar"
                            value={userData.aadhar_no}
                        />

                    </SimpleGrid>

                </Paper>

                <Paper withBorder radius="md" p="lg" mt="lg">

                    <Title order={4}>
                        Account Information
                    </Title>

                    <SimpleGrid cols={2} mt="md">

                        <Info
                            label="User Code"
                            value={userData.userCode}
                        />

                        <Info
                            label="Role"
                            value={userData.acc_type}
                        />

                        <Info
                            label="Password Changed"
                            value={
                                userData.ispasswordchanged
                                    ? "Yes" : "No"
                            }
                        />

                        <Info
                            label="MPIN Changed"
                            value={
                                userData.ismpinchanged
                                    ? "Yes" : "No"
                            }
                        />

                        <Info
                            label="Created"
                            value={dayjs(userData.createdAt).format("DD MMM YYYY")}
                        />

                    </SimpleGrid>

                </Paper>

                <Paper withBorder radius="md" p="lg" mt="lg">

                    <Title order={4}>
                        Hierarchy
                    </Title>

                    <SimpleGrid cols={2} mt="md">

                        <Info
                            label="Master Distributor"
                            value={userData.master_dist_id?.userName}
                        />

                        <Info
                            label="Distributor"
                            value={userData.distributor_id?.userName}
                        />

                        {/* <Info
                            label="Approved By"
                            value={userData.appoved_by}
                        /> */}

                    </SimpleGrid>

                </Paper>

            </Drawer>
            <Card className='card' radius={0}>
                <Group justify="space-between" h="100%">
                    <Group justify="flex-start">
                        <Title size={'md'} c={'white'}>{Headername}</Title>
                    </Group>

                    <Group justify="flex-end">
                        <Paper
                            withBorder
                            radius="md"
                            p="xs"
                            style={{ cursor: "pointer" }}
                            onClick={() => setWalletDrawer(true)}
                        >
                            <Group justify="space-between">

                                <Group>

                                    <ThemeIcon
                                        color={userWallet?.isWalletBlocked ? "red" : "green"}
                                        variant="light"
                                        radius="xl"
                                        size={45}
                                    >
                                        <IconWallet size={22} />
                                    </ThemeIcon>

                                    <div>

                                        <Text
                                            c="dimmed"
                                            size="xs"
                                            fw={700}
                                            tt="uppercase"
                                        >
                                            Main Wallet
                                        </Text>

                                        <Skeleton visible={userWalletloading}>
                                            <Text fw={700} size="lg">
                                                ₹ {wallet?.mainBalance?.toLocaleString()}
                                            </Text>
                                        </Skeleton>

                                    </div>

                                </Group>

                                <IconChevronRight size={18} />

                            </Group>
                        </Paper>
                        {/* <Paper withBorder radius="md" p="xs">
                            <Group>

                                <Center>
                                    <IconWallet size={20} stroke={1.5} color={userWallet?.isWalletBlocked ? 'red' : 'green'} />
                                </Center>

                                <div>
                                    <Skeleton height={'auto'} visible={userWalletloading}>
                                        <Text c="dimmed" size="xs" tt="uppercase" fw={700}>
                                            Main Wallet
                                        </Text>
                                        <Text fw={700} size="sm">
                                            ₹{userWallet?.mainBalance}
                                        </Text>
                                    </Skeleton>
                                </div>

                            </Group>
                        </Paper> */}

                        <Menu
                            width={260}
                            position="bottom-end"
                            transitionProps={{ transition: 'pop-top-right' }}
                            onClose={() => setUserMenuOpened(false)}
                            onOpen={() => setUserMenuOpened(true)}
                            withinPortal
                        >
                            <Menu.Target>
                                <UnstyledButton
                                    className={cx("user", { userActive: userMenuOpened })}
                                >
                                    <Skeleton visible={userLoading}>
                                        <Group gap="sm" wrap="nowrap">

                                            <Avatar
                                                name={userData?.userName}
                                                radius="xl"
                                                size={42}
                                                color="initials"
                                            />

                                            <div style={{ lineHeight: 1.2 }}>

                                                <Text
                                                    fw={600}
                                                    size="sm"
                                                    c="white"
                                                >
                                                    {userData?.userName}
                                                </Text>

                                                <Text
                                                    size="xs"
                                                    c="rgba(255,255,255,.75)"
                                                >
                                                    {userData?.userCode}
                                                </Text>

                                            </div>

                                            <IconChevronDown
                                                size={18}
                                                color="white"
                                                stroke={2}
                                            />

                                        </Group>
                                    </Skeleton>
                                </UnstyledButton>
                            </Menu.Target>
                            <Menu.Dropdown>
                                <Text fw={500} size="xs" p={'xs'} c={'dimmed'}>
                                    Code: {userData?.userCode}
                                </Text>
                                <Menu.Item
                                    leftSection={<IconUser size={16} color={theme.colors.red[6]} stroke={1.5} />}
                                    onClick={() => setUserprofileDrawer(true)}
                                >
                                    Profile
                                </Menu.Item>
                                {/* <Menu.Item
                                    leftSection={<IconStar size={16} color={theme.colors.yellow[6]} stroke={1.5} />}
                                >
                                    Saved posts
                                </Menu.Item>
                                <Menu.Item
                                    leftSection={<IconMessage size={16} color={theme.colors.blue[6]} stroke={1.5} />}
                                >
                                    Your comments
                                </Menu.Item> */}

                                <Menu.Label>Settings</Menu.Label>
                                <Menu.Item leftSection={<IconSettings size={16} stroke={1.5} />} onClick={accountSettings_redirect}>
                                    Account settings
                                </Menu.Item>
                                {/* <Menu.Item leftSection={<IconSwitchHorizontal size={16} stroke={1.5} />}>
                                    Change account
                                </Menu.Item> */}
                                <Menu.Item leftSection={<IconLogout size={16} stroke={1.5} />} onClick={Logout_user}>Logout</Menu.Item>

                                {/* <Menu.Divider />

                                <Menu.Label>Danger zone</Menu.Label>
                                <Menu.Item leftSection={<IconPlayerPause size={16} stroke={1.5} />}>
                                    Pause subscription
                                </Menu.Item>
                                <Menu.Item color="red" leftSection={<IconTrash size={16} stroke={1.5} />}>
                                    Delete account
                                </Menu.Item> */}
                            </Menu.Dropdown>
                        </Menu>
                    </Group>
                </Group>
            </Card>

        </>
    )
}
export default Topnavbar;